import {
  LOAD_FAVOURITES,
  TOGGLE_FAVOURITE,
  UPDATE_FAVOURITE_ORDER
} from './constants'
import { getCustomer } from '../../helpers/utils'

const initialState = { items: [] }

export default function favouritesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_FAVOURITES: {
      // always move customer favourites to the start in order for drag and drop to work correctly
      const customer = getCustomer()
      const customerFavourites = action.favourites.filter(
        (fav) => fav.customer === customer
      )
      const restFavourites = action.favourites.filter(
        (fav) => fav.customer !== customer
      )
      return {
        ...state,
        items: [...customerFavourites, ...restFavourites]
      }
    }

    case UPDATE_FAVOURITE_ORDER: {
      return {
        ...state,
        items: action.favourites
      }
    }

    case TOGGLE_FAVOURITE: {
      const favourites = state.items.slice()
      const existingIndex = favourites.findIndex(
        (fav) => JSON.stringify(fav) === JSON.stringify(action.favourite)
      )

      if (existingIndex !== -1) {
        favourites.splice(existingIndex, 1)
        return {
          ...state,
          items: favourites
        }
      }

      return {
        ...state,
        items: [action.favourite, ...state.items]
      }
    }

    default: {
      return state
    }
  }
}
